export default __webpack_public_path__ + "static/media/Lato-Bold.89b61808.woff";